const testimonials = [
  {
    name: "Major David R.",
    location: "Kirtland AFB, NM",
    rating: 5,
    text: "Received deployment orders to Ramstein with 21 days to report. My wife's passport was expired and our son never had one. Fast Passport Center walked us through the dependent process, reviewed every document, and got both passports back in seven business days. That is the difference between making my report date and missing it. Cannot recommend them enough to any military family at Kirtland.",
    service: "Family Expedited Passports",
  },
  {
    name: "Dr. Elena M.",
    location: "Nob Hill, Albuquerque",
    rating: 5,
    text: "I am a researcher at Sandia National Labs and had an international collaboration meeting in Stuttgart with less than two weeks notice. My passport expired during the pandemic when travel was restricted. Fast Passport Center had my renewal processed and back to me in five business days. I made my flight out of ABQ without any issues. Professional, efficient, and absolutely worth it.",
    service: "Passport Renewal",
  },
  {
    name: "Carlos & Maria G.",
    location: "Rio Rancho, NM",
    rating: 5,
    text: "We had a family reunion in Chihuahua, Mexico planned for months — then realized our daughter's passport expired and the two younger kids never had one. Called Fast Passport Center, they walked us through the child passport process, reviewed everything, and we had all three in eight business days. We made the reunion. The team was incredibly patient with all our questions.",
    service: "Family Passport Services",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function AlbuquerqueTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What New Mexico Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Albuquerque, Kirtland AFB, and Rio Rancho travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}